import LaborItemDetailWrapper from "./LaborItemDetailWrapper.vue";
import Head from './../components/Head.vue';
export default {
  components: {
    LaborItemDetailWrapper,
    Head
  },

  data() {
    return {
      id: this.$utils.getUrlParams('detailId'),
      master_name: null,
      classify_name: null,
      laboratoryItemDetail: {},
      menuInfo: {}
    };
  },

  mounted() {
    this.$nextTick(() => {
      window.scroll(0, 0);
    });
  },

  created() {
    this.getVRByIdItemDetail();
  },

  methods: {
    jumpCatergory() {
      window.open(this.laboratoryItemDetail.experiment_link);
    },

    // 获取仿真实验基础详情
    async getVRByIdItemDetail() {
      const data = await this.$http.getVRById({
        id: this.id
      });
      this.laboratoryItemDetail = data;
    },

    laboratoryItemHeido(url) {
      if (url) window.open(url, "_blank");
    }

  }
};